import classes from "./BoxEntity.module.css";

const BoxEntity = ({ className, icon, content, styleValue, value, date }) => {
  return (
    <div
      className={[classes.boxEntity, classes.gridContainer, className].join(
        " ",
      )}
    >
      <div
        className={classes.boxEntity_icon}
        style={{
          // backgroundColor: "white",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {icon && icon !== "-" && icon.includes("im") ? (
          <i className={icon}></i>
        ) : (
          <img src={icon} alt="icon" width="36px" />
        )}
      </div>
      <p className={classes.boxEntity_content}>
        <span>{content}</span>
        <span
          style={{
            fontSize: "10px",
          }}
        >
          {date}
        </span>
      </p>
      <div className={classes.boxEntity_value} style={styleValue}>
        {value}
      </div>
    </div>
  );
};
export default BoxEntity;
